import React, { Component, Fragment } from "react";
import { createPortal } from "react-dom";
import { message, Select } from "antd";
import Panel from "../../../../../components/Panel";
import { getPanelMaxHeight, getPanelMaxWidth, getPanelWidth } from "../../../../../services/helper/panelSizeHelper";
import sierraLibrary from "../../../../../services/Sierra/library/libraryStorage";
import { getIbisModelList, getSpiceModelList, ModelSelectHelper } from '../../../../../services/Sierra/library';
import IBISRender from './ibisRender';
import SPICERender from './spiceRender';
import "../index.css";
import { RX_MODEL_TYPES, TX_MODEL_TYPES } from "../../../../../services/LibraryHelper";

const IBIS = "IBIS", SPICE = "SPICE";
class ModelSelectPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      maxHeight: 0,
      maxWidth: 0,
      // modelInfo: { libType: '', fileName: '', modelName: '', libraryId: '' },
      libType: IBIS,
      fileName: '',
      libraryId: '',
      modelName: '',
      modelType: '',
      enableVoltage: '',
      deviceVcc: '',
      version: '',
      // ibis state
      modelNameList: [],
      modelTypeList: [],
      modelSelectorList: [],
      modelSelector: '',
      // spice state
      subcktNames: [], // {name, ports: []}
    }
    this.dialogRoot = document.getElementById("root");
  }


  componentDidMount() {
    this.resize()
    window.addEventListener('resize', this.resize);

    // init data
    const { model = {} } = this.props;
    const ibisList = [...sierraLibrary.getTree(IBIS.toLowerCase())];
    const spiceList = [...sierraLibrary.getTree(SPICE.toLowerCase())];

    this.setState({
      ...model,
      ibisList,
      spiceList
    }, () => {
      if (model.libType === IBIS) {
        this.getIbisModels(model);
      } else if (model.libType === SPICE) {
        this.getSpiceModels(model);
      }
    })
  }

  componentDidUpdate(prevProps) {
    const { libraryTreeInfo } = this.props;
    const judgeLibraryTreeInfo = (type) => ((libraryTreeInfo || []).includes(type) && !(prevProps.libraryTreeInfo || []).includes(type));
    if (judgeLibraryTreeInfo(IBIS.toLowerCase())) {
      this.setState({ ibisList: [...sierraLibrary.getTree(IBIS.toLowerCase())] });
    }

    if (judgeLibraryTreeInfo(SPICE.toLowerCase())) {
      this.setState({ spiceList: [...sierraLibrary.getTree(SPICE.toLowerCase())] });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxHeight: getPanelMaxHeight(offset, 700),
      maxWidth: getPanelMaxWidth(offset, 500)
    })
  }

  getIbisModels({ fileName, modelType, modelName, libraryId }) {
    const { dataIndex } = this.props;
    if (libraryId) {
      let obj = {
        libraryId,
        usage: dataIndex === 'txModel' ? 'Tx' : 'Rx'
      }
      getIbisModelList(obj).then(models => {
        const modelList = ModelSelectHelper.getSortedList(models);
        const modelTypeList = ModelSelectHelper.getModelTypeList(models.models);
        const modelSelectorList = ModelSelectHelper.getModelSelectorListList(models.selectorModels);
        let modelNameList = [...modelList];
        let modelSelector = "";
        if (modelType || modelName) {
          if (modelName) {
            const find = modelList.find(item => item.name === modelName);
            if (find) {
              modelSelector = find.selector;
            }
          }
          modelNameList = ModelSelectHelper.filterModelNameList({ modelList, modelType, modelSelector })
        }
        this.setState({
          modelList,
          modelNameList,
          modelTypeList,
          modelSelectorList,
          modelSelector
        })
      }).catch(() => {
        this.setState({
          modelList: [],
          modelTypeList: [],
          modelSelectorList: [],
          modelNameList: [],
          modelSelector: "",
        })
      })
    } else if (fileName) {
      message.error(`Not found ${fileName} file.`);
    }
  }

  getSpiceModels({ fileName, modelType, modelName, libraryId }) {
    if (!libraryId) {
      this.setState({
        subcktNames: []
      })
      return;
    }

    if (libraryId) {
      const { type, dataIndex } = this.props;
      const obj = {
        libraryId,
        fileName,
        usage: type === 'tx' ? 'Tx' : 'Rx',
      }
      getSpiceModelList(obj).then(model => {
        let models = model && model.models ? model.models : [];
        const isRx = dataIndex === "rxModel";
        let bufferType = ""
        if (isRx && RX_MODEL_TYPES.includes(modelType)) {
          bufferType = modelType;
        } else if (!isRx && TX_MODEL_TYPES.includes(modelType)) {
          bufferType = modelType;
        } else if (isRx) {
          bufferType = "Input";
        }

        let subckt = null;
        if (modelName && models && models.find(it => it.name === modelName)) {
          subckt = modelName;
        } else if (models && models.length === 1) {
          subckt = models[0].name;
        }

        this.setState({
          subcktNames: models || [],
          modelType: bufferType,
          modelName: subckt
        })
      }).catch(error => {
        console.warn(error);
      })
    } else {
      message.error(`Not found ${fileName} file.`)
    }
  }

  onLibTypeChange = (libType) => {
    this.setState({
      libType,
      fileName: '',
      libraryId: '',
      modelName: '',
      modelType: '',
      enableVoltage: '',
      version: '',
    }, () => {

    })
  }

  onFolderFileChange = (item) => {
    const { id, libraryStructure, version } = item;
    if (!id || !libraryStructure) {
      return;
    }

    const { libType } = this.state;
    this.setState({
      libraryId: id,
      fileName: libraryStructure.name,
      version
    }, () => {
      const model = {
        libraryId: id,
        fileName: libraryStructure.name,
      }
      if (libType === IBIS) {
        this.getIbisModels(model);
      } else if (libType === SPICE) {
        this.getSpiceModels(model);
      }
    })
  }

  setData = (data) => {
    this.setState({ ...data });
  }

  closeModal = () => {
    const { libType, fileName, libraryId, modelName, modelType, enableVoltage, version } = this.state;
    const { record, dataIndex } = this.props;
    this.props.handleSave({ ...record, [dataIndex]: { libType, fileName, libraryId, modelName, modelType, enableVoltage, version } }, record);
    this.props.save && this.props.save();
  }

  render() {
    const { maxHeight, maxWidth, libType } = this.state;
    const { title, dataIndex } = this.props;

    const content = (
      <Fragment>
        <Panel
          title={title}
          className='sierra-part-library-panel sierra-panel'
          position='panel-center-top'
          minHeight={200}
          minWidth={100}
          width={getPanelWidth(maxWidth, { defaultWidth: 700 })}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          onCancel={() => this.closeModal()}
          draggable
          zIndex={2000}
        >
          <div className="sierra-model-select-panel-content">
            <div className="div-flex-box">
              <label>Buffer</label>
              <Select
                className="input-component"
                size="small"
                options={[{ label: "IBIS", value: IBIS }, { label: "SPICE", value: SPICE }]}
                value={libType}
                onChange={this.onLibTypeChange}
              />
            </div>
            {libType === IBIS
              ? <IBISRender
                {...this.state}
                onFolderFileChange={this.onFolderFileChange}
                setData={this.setData}
              />
              : <SPICERender
                {...this.state}
                bufferTypes={dataIndex === 'txModel' ? TX_MODEL_TYPES : RX_MODEL_TYPES}
                onFolderFileChange={this.onFolderFileChange}
                setData={this.setData}
              />}
          </div>
        </Panel>
      </Fragment>
    );
    return createPortal(content, this.dialogRoot)
  }
}

export default ModelSelectPanel;